const ProgressLoader =()=>{

    return (
        <div className="linear-loading bg-primary-navbar"></div>
      )
}
export default ProgressLoader;